import { Alert, Col, Modal, Row, Table, Typography } from 'antd';
import { Activity } from 'react';

const TemplateModal = ({ open, onClose, type }) => {
    return (
        <Modal title="Excel Template Example" open={open} footer={null} onCancel={onClose} width={800}>
            <Typography.Paragraph>Upload an Excel file with the following columns:</Typography.Paragraph>

            <Row gutter={8}>
                <Activity mode={type === 4 ? 'hidden' : 'visible'}>
                    <Col xs={24} md={type === 1 ? 24 : 12}>
                        <Typography.Title level={5}>Promotion Products</Typography.Title>
                        <Table
                            size="small"
                            bordered
                            pagination={false}
                            dataSource={[
                                {
                                    key: 1,
                                    customer_code: 'A162',
                                    product_code: 'A1003',
                                    price: '15.99',
                                },
                                {
                                    key: 2,
                                    customer_code: 'A155',
                                    product_code: 'A1004',
                                    price: '19.99',
                                },
                                {
                                    key: 3,
                                    customer_code: 'A156',
                                    product_code: 'A1001',
                                    price: '20.99',
                                },
                            ]}
                            columns={[
                                { title: 'product_code', dataIndex: 'product_code', },
                                { title: 'price', dataIndex: 'price', }
                            ]}
                        />
                    </Col>
                </Activity>

                <Activity mode={type === 1 ? 'hidden' : 'visible'}>
                    <Col xs={24} md={type === 1 || type === 4 ? 24 : 12}>
                        <Typography.Title level={5}>Customers {type === 4 && 'Product'}</Typography.Title>
                        <Table
                            size="small"
                            bordered
                            pagination={false}
                            dataSource={[
                                {
                                    key: 1,
                                    customer_code: 'A162',
                                    product_code: 'A1003',
                                    price: '15.99',
                                },
                                {
                                    key: 2,
                                    customer_code: 'A155',
                                    product_code: 'A1004',
                                    price: '19.99',
                                },
                                {
                                    key: 3,
                                    customer_code: 'A156',
                                    product_code: 'A1001',
                                    price: '20.99',
                                },
                            ]}
                            columns={[
                                { title: 'customer_code', dataIndex: 'customer_code', },
                                { title: 'product_code', dataIndex: 'product_code', hidden: type !== 4 },
                                { title: 'price', dataIndex: 'price', hidden: type !== 4 }
                            ]}
                        />
                    </Col>
                </Activity>
            </Row>

            <Alert
                type="warning"
                showIcon
                className="mt-2"
                message="Make sure column headers exactly match the names above (case-sensitive)."
            />
        </Modal>
    );
};

export default TemplateModal;
